/**
 * Derive a coarse "service" tag from a path so we can segment funnel
 * conversion by the offering the user was looking at when they entered the
 * experiment (dog vs deer vs garden vs restoration vs other).
 *
 * Order matters — most specific first.
 */
export function serviceFromPath(path: string): string {
  if (!path) return "other";
  const p = path.toLowerCase();
  if (p.includes("/dog-fence") || p.includes("/dog-")) return "dog";
  if (p.includes("/deer-fence") || p.includes("/deer-")) return "deer";
  if (p.includes("/garden-fence") || p.includes("/garden-")) return "garden";
  if (p.includes("/fence-restoration") || p.includes("restoration")) return "restoration";
  if (p.includes("/beat-my-estimate")) return "beat-estimate";
  if (p === "/" || p === "") return "home";
  if (p.startsWith("/locations")) return "location";
  if (p.startsWith("/contact")) return "contact";
  if (p.startsWith("/book")) return "book";
  if (p.startsWith("/learn")) return "learn";
  return "other";
}

/** Safe accessor — works in SSR / non-browser contexts. */
export function currentPagePath(): string {
  if (typeof window === "undefined") return "";
  try {
    return window.location.pathname || "";
  } catch {
    return "";
  }
}

export function currentService(): string {
  return serviceFromPath(currentPagePath());
}
